// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"240":"news-center","440":"news-detail","462":"feature-intro","467":"download","492":"download-guide","804":"company-profile","962":"home"}[chunkId] + "." + {"240":"34f41827","440":"f3b3dac7","462":"9f7466ea","467":"c7cc0233","492":"c00bfaf1","804":"5c1b4ff6","962":"f209fe53"}[chunkId] + ".css";
};